import HeaderIcon from './HeaderIcon';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useState } from 'react';
import {Link, useMatch, useNavigate, useParams } from "react-router-dom";
import useUser from '../hooks/useUser';
import { useLocation } from 'react-router-dom';


import{
    ChevronDownIcon,        
    UserIcon
} from "@heroicons/react/24/solid";

import { faPersonDigging, faFileInvoiceDollar, faHome, faClipboardList, faCalendar, faCalendarPlus, faBars, faFireExtinguisher, faFileAlt } from '@fortawesome/free-solid-svg-icons'
import WriteLog from './Globals/WriteLog';

function Header({routing}){
                
    const {user, setUser} = useUser();
    const location = useLocation();    
    WriteLog("Header->routing", routing);
    const match = useMatch(routing)
    WriteLog("Header->location", location);    
            
     //menu
     const [showMenu, setShowMenu] = useState(false);
     const closeMenu = () => setShowMenu(false);
     const navigate = useNavigate();

    WriteLog("Header->User",user);
    
    //if(!user) return <Login setUser={setUser} />;

    async function logOut(event) {    
        event.preventDefault()
        setShowMenu(false)
        setUser("")
        navigate("/login")        
      }
      
    //Routing path
    const {id} = useParams();    
    //const isBrowser = () => typeof window !== undefined  
    // var routingPath = ""
    // if(isBrowser())
    // {      
    //     routingPath   = window && window.location.pathname
    // }          
    WriteLog("Header->routingPath",window.location);    
    WriteLog("Header->id", id);    
    return (        
        <div className='sticky top-0 z-50  bg-white flex items-center lg:px-2 shadow-md'>                   
            {/* Left */}
            <div className='flex items-center'>
                <div><img src="/logo.png" width ={50}  height={50} layout ='fixed' alt='logo' /></div>
                <div><p className='font-semibold text-gray-800'>PFP Canada</p></div>                                
            </div>                                    
            {/* Center */}
            <div className='flex flex-grow justify-center'>
                <div className='flex justify-evenly w-1/2 space-x-6 md:space-x-2'>
                    <Link to="/dashboard">
                        <div>
                            <HeaderIcon hero={false} active={location?.pathname === "/dashboard" ? "active":""} Icon={faHome} title="Home" /> 
                        </div>                    
                    </Link>
                    <Link to="/workorder/addr_seq/0">
                        <div>
                            <HeaderIcon hero={false} active={location?.pathname === "/workorder/addr_seq/"+match?.params?.id ? "active":""} Icon={faFileAlt} title="Home" /> 
                        </div>                    
                    </Link>                    
                    <Link to="/schedule/addr_seq/0">
                        <div>
                            <HeaderIcon hero={false} active={location?.pathname === "/schedule/addr_seq/"+match?.params?.id ? "active":""} Icon={faCalendar} title="Schedule" />      
                        </div>                    
                    </Link>
                    {/* <Link to="/booking/addr_seq/0">
                        <div>
                            <HeaderIcon hero={false} active={location?.pathname === "/booking/addr_seq/"+match?.params?.id ? "active":""} Icon={faCalendarPlus} title="Booking" />      
                        </div>                    
                    </Link> */}
                    <Link to="/report/addr_seq/0">   
                        <div>
                            <HeaderIcon hero={false} active={location?.pathname === "/report/addr_seq/"+match?.params?.id ? "active":""} Icon={faClipboardList} title="Report" /> 
                        </div>                          
                    </Link>
                    <Link to="/invoice/status/0">   
                        <div>
                            <HeaderIcon hero={false} active={location?.pathname === "/invoice/status/"+match?.params?.id ? "active":""} Icon={faFileInvoiceDollar} title="Invoice" /> 
                        </div>
                    </Link>
                    <Link to="/equipment/addr_seq/0">   
                        <div>
                            <HeaderIcon hero={false} active={location?.pathname === "/equipment/addr_seq/"+match?.params?.id? "active":""} Icon={faFireExtinguisher} title="Equipment" /> 
                        </div>  
                    </Link>
                    <Link to="/estimate/addr_seq/0">   
                        <div>
                            <HeaderIcon hero={false} active={location?.pathname === "/estimate/addr_seq/"+match?.params?.id? "active":""} Icon={faPersonDigging} title="Estimate" /> 
                        </div>  
                    </Link>
                    <Link to="/misc">   
                        <div>
                            <HeaderIcon hero={false} active={location?.pathname === (match?.params?.id === undefined ? "/misc":"/misc/"+match?.params?.id) ? "active":""} Icon={faBars} title="Estimate" /> 
                        </div>  
                    </Link>                    
                </div>                
            </div>
            {/* Right */}            
            <div>                                  
                {user &&
                    <div className='flex justify-end items-center space-x-2'>                        
                    <div><UserIcon className='bg-orange-400 text-white rounded-full w-8 h-8 p-1'/></div>   
                    <div className=' whitespace-nowrap font-semibold'>
                        {user?.full_name}
                    </div>   
                    <div>
                        <ChevronDownIcon onClick={() => setShowMenu(true)} className='icon'></ChevronDownIcon> 
                    </div>
                    <Popup className='bg-gray-400' open={showMenu} closeOnDocumentClick trigger={<div></div>}  position="left center" onClose={closeMenu}>                            
                        <div onClick={logOut} className='flex space-x-1 cursor-pointer hover:bg-gray-100 items-center'>
                            <div><UserIcon className='bg-slate-400 text-white rounded-full h-5 w-5' /></div>
                            <div>Logout</div>
                        </div>                            
                    </Popup>                  
                    </div>                                                  
                }                                
            </div>
        </div>
    )
}
export default Header
